import React from "react";
import callIcon from "../../assets/icons/callIcon.svg";
import emailIcon from "../../assets/icons/emailIcon.svg";
import timeIcon from "../../assets/icons/timeIcon.svg";
import "./Header1.css";


function Header1(){
    return(
        <>
        <header className="header1">

  <div className="header1_elements header1_phone">
    <img src={callIcon} className="header1_icon"/>
    <h3 className="header1_headings">
      +971 52 174 3345
    </h3>
  </div>

  <div className="header1_elements header1_email">
    <img src={emailIcon} className="header1_icon"/>
    <h3 className="header1_headings">
      info@ainalsadapropertycare.ae
    </h3>
  </div>

  <div className="header1_elements header1_time">
    <img src={timeIcon} className="header1_icon"/>
    <h3 className="header1_headings">
      24/7 Emergency Service Available
    </h3>
  </div>

</header>
        </>
    )
}
export default Header1